const specHeadings = [...document.querySelectorAll('.js-product-tabs-heading')];

specHeadings.map(heading => heading.addEventListener('click', () => {
    if (heading.hasAttribute('data-open')) {
        heading.nextElementSibling.style.height = 0;
        heading.removeAttribute('data-open');
    } else {
        specHeadings.map(h => { h.removeAttribute('data-open'); h.nextElementSibling.style.height = 0;});
        heading.setAttribute('data-open', '');
        heading.nextElementSibling.style.height = `${heading.nextElementSibling.scrollHeight}px`;
    }
}));
